import React, { useEffect, useState } from "react";
import {
  CategoriesResponse,
  ISearch,
  ISearchRequest,
  SubcategoriesResponse,
} from "../../types/types";
import "./SearchPage.css";
import Button from "../../components/Button/Button";
import Dropdown from "../../components/Dropdown/Dropdown";
import Slab from "../../components/Slab/Slab";
import FavRequestModal from "../../components/Modal/FavRequestModal/FavRequestModal";
import { Link, useNavigate, useParams } from "react-router-dom";
import { handlePrice } from "../../utils/formatdate";
import {
  FetchCategorieslookup,
  FetchSubcategorieslookup,
} from "../../services/lookup.service";
import { FavRequest } from "../../services/favRequest.service";
import { handleMessage } from "../../utils/handleMessagePopup";
import { IFavRequest } from "../../types/types";
import InputBox from "../../components/Input/Input";
import { StripeCheckoutForm } from "../../components/Stripe/StripeCheckoutForm/StripeCheckoutForm";
import useAuthService from "../../auth/AuthService";
import { UserNameModal } from "../../components/Modal/UserNameModal/UserNameModal";
import { CheckUserName } from "../../services/username.service";
import { trackEvent } from "../../utils/ga";
import {
  SearchResultWithFilter,
  SearchResultWithToken,
} from "../../services/search.service";
import Table from "../../components/Table/Table";
import AuctionModal from "../../components/Modal/AuctionModal/AuctionModal";

const SearchPage = () => {
  const { isAuthenticated, getToken, login } = useAuthService();

  const [state, setState] = useState({
    selectedSubcategories: [] as string[],
    selectedCategory: "",
    isOpen: false,
    isFilterOpen: false,
    isProcessing: false,
    isFavModalOpen: false,
    isBidNow: false,
    isLoading: false,
    searches: [] as ISearch[],
    categories: [] as CategoriesResponse[],
    subcategories: [] as SubcategoriesResponse[],
    secondfilter: "",
    maxPrice: "",
    maxValue: "",
    isCheckoutModal: false,
    selectedItemId: {} as ISearch,
    isUserNameModal: false,
    // fan_id: "00000000-0000-0000-0000-000000000000",
    status: "",
  });
  const [filter, setFilter] = useState({
    main: "all",
    sub: "",
  });

  const [formData, setFormData] = useState<IFavRequest>({
    favname: "",
    email: "",
  });

  const { query } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async (data: any) => {
      try {
        const request: ISearchRequest = {
          query: data,
        };
        let response: any = null;
        handleToggle("isLoading", !state.isLoading);
        if (isAuthenticated) {
          response = await SearchResultWithToken(request, getToken);
        } else {
          response = await SearchResultWithFilter(request);
        }
        if (response.error) {
          setState((pre) => ({
            ...pre,
            searches: [],
          }));
          return;
        }
        setState((pre) => ({
          ...pre,
          searches: Array.isArray(response.data) ? response.data : [],
        }));
      } catch (err) {
        console.error("Error in fetching search results:", err);
      } finally {
        handleToggle("isLoading", false);
      }
    };
    fetchData(query);
    //eslint-disable-next-line
  }, [isAuthenticated, query]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const CategoryResponse = await FetchCategorieslookup();
        if (CategoryResponse.error) {
          setState((pre) => ({
            ...pre,
            categories: [],
          }));
          return;
        }
        setState((pre) => ({
          ...pre,
          secondfilter: "",
          categories: Array.isArray(CategoryResponse.data)
            ? CategoryResponse.data
            : [],
        }));
      } catch (err) {
        console.error("Error in fetching Category results:", err);
      }
    };
    fetchData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let request = "";
      if (filter.main !== "all") {
        request = state.selectedCategory;
      }
      const SubcategoryResponse = await FetchSubcategorieslookup(request);
      if (SubcategoryResponse.error) {
        setState((pre) => ({ ...pre, isLoading: false, subcategories: [] }));
        return;
      }
      setState((pre) => ({
        ...pre,
        subcategories: Array.isArray(SubcategoryResponse.data)
          ? SubcategoryResponse.data
          : [],
      }));
    };
    fetchData();
  }, [state.selectedCategory, filter.main]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFavRequest = async () => {
    try {
      const response = await FavRequest(formData);
      if (response.error == null) {
        handleMessage("Request submitted successfully");
        setState((pre) => ({ ...pre, isFavModalOpen: false }));
        trackEvent(
          "submit_fav_request",
          JSON.stringify({ favname: formData.favname })
        );
      } else {
        handleMessage("Please send your request");
      }
    } catch {
      console.error("Unable to submit request");
    }
  };

  const handleMainFilter = async (filter: string, value?: string) => {
    try {
      trackEvent("category_filtered", JSON.stringify({ filter, value }));
      setFilter(() => ({ main: filter, sub: "" }));
      handleToggle("isLoading", true);
      let request: ISearchRequest = {
        query: query as string,
        category_id: value as string,
        subcategory_ids: [],
        second_filter: state.secondfilter,
      };
      if (
        parseFloat(state.maxValue) > 0 &&
        state.secondfilter !== "available"
      ) {
        request = { ...request, max_value: parseFloat(state.maxValue) };
      }
      if (parseFloat(state.maxPrice) > 0) {
        request = { ...request, max_price: parseFloat(state.maxPrice) };
      }
      const response = isAuthenticated
        ? await SearchResultWithToken(request, getToken)
        : await SearchResultWithFilter(request);
      if (response.error) {
        console.error(response.error);
        return;
      }
      setState((pre) => ({
        ...pre,
        selectedCategory: value ? value : "",
        selectedSubcategories: [],
        searches: response.data,
      }));
    } catch {
    } finally {
      handleToggle("isLoading", false);
    }
  };

  const handleMaxFilters = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: type === "number" ? (value ? parseFloat(value) : "") : value,
    }));

    try {
      trackEvent(
        "price_filter_updated",
        JSON.stringify({ filterType: name, value })
      );
      handleToggle("isLoading", true);
      let request: ISearchRequest = {
        query: query as string,
        subcategory_ids: state.selectedSubcategories,
        second_filter: state.secondfilter,
      };

      if (filter.main !== "all") {
        request = { ...request, category_id: state.selectedCategory };
      }

      if (name === "maxPrice") {
        request = { ...request, max_price: parseFloat(value) };
        if (
          parseFloat(state.maxValue) > 0 &&
          state.secondfilter !== "available"
        ) {
          request = { ...request, max_value: parseFloat(state.maxValue) };
        }
      } else if (name === "maxValue") {
        request = { ...request, max_value: parseFloat(value) };
        if (parseFloat(state.maxPrice) > 0) {
          request = { ...request, max_price: parseFloat(state.maxPrice) };
        }
      }

      const response = isAuthenticated
        ? await SearchResultWithToken(request, getToken)
        : await SearchResultWithFilter(request);
      if (response.error) {
        console.error(response.error);
        return;
      }
      setState((pre) => ({
        ...pre,
        searches: response.data,
        isLoading: false,
      }));
    } catch (err) {
      console.error("Error in getting search results. ", err);
      handleToggle("isLoading", false);
    }
  };

  const handleSecondFilter = async (secondFilter: string) => {
    try {
      setState((pre) => ({
        ...pre,
        secondfilter: secondFilter,
        isLoading: true,
      }));
      let request: ISearchRequest = {
        query: query as string,
        subcategory_ids: state.selectedSubcategories,
        second_filter: secondFilter,
      };

      if (filter.main !== "all") {
        request = { ...request, category_id: state.selectedCategory };
      }

      if (parseFloat(state.maxPrice) > 0) {
        request = { ...request, max_price: parseFloat(state.maxPrice) };
      }

      if (parseFloat(state.maxValue) > 0) {
        if (secondFilter !== "available") {
          request = { ...request, max_value: parseFloat(state.maxValue) };
        }
      }

      const response = isAuthenticated
        ? await SearchResultWithToken(request, getToken)
        : await SearchResultWithFilter(request);

      if (response.error) {
        console.error(response.error);
        return;
      }
      setState((pre) => ({
        ...pre,
        searches: response.data,
      }));
    } finally {
      handleToggle("isLoading", false);
    }
  };

  const handleSubFilter = async (filter: string) => {
    setFilter((pre) => ({ ...pre, sub: filter }));
  };

  const handleToggle = (key: keyof typeof state, value?: boolean) => {
    setState((pre) => ({ ...pre, [key]: value ? value : !pre[key] }));
  };

  const handleSubcategorySelection = async (subcategory: string) => {
    try {
      trackEvent("subcategory_selected", JSON.stringify({ subcategory }));
      const subcategories = [...state.selectedSubcategories, subcategory];
      let request: ISearchRequest = {
        query: query as string,
        subcategory_ids: subcategories,
        second_filter: state.secondfilter,
      };
      handleToggle("isLoading", true);
      if (filter.main !== "all") {
        request = { ...request, category_id: state.selectedCategory };
      }
      const response = isAuthenticated
        ? await SearchResultWithToken(request, getToken)
        : await SearchResultWithFilter(request);
      setState((prevState) => {
        const updatedSubcategories = prevState.selectedSubcategories.includes(
          subcategory
        )
          ? prevState.selectedSubcategories.filter(
              (item) => item !== subcategory
            )
          : [...prevState.selectedSubcategories, subcategory];

        return {
          ...prevState,
          selectedSubcategories: updatedSubcategories,
          searches: response.data,
        };
      });
      state.selectedSubcategories.length >= 0 && handleSubFilter("subcategory");
    } finally {
      handleToggle("isLoading", false);
    }
  };

  const handleRemoveSubcategory = async (subcategory: string) => {
    try {
      trackEvent("subcategory_removed", JSON.stringify({ subcategory }));
      const subcategories = state.selectedSubcategories.filter(
        (value) => value !== subcategory
      );
      let request: ISearchRequest = {
        query: query as string,
        subcategory_ids: subcategories,
        second_filter: state.secondfilter,
      };
      handleToggle("isLoading", true);
      if (filter.main !== "all") {
        request = { ...request, category_id: state.selectedCategory };
      }
      const response = isAuthenticated
        ? await SearchResultWithToken(request, getToken)
        : await SearchResultWithFilter(request);
      setState((prevState) => ({
        ...prevState,
        selectedSubcategories: prevState.selectedSubcategories.filter(
          (item) => item !== subcategory
        ),
        searches: response.data,
      }));
      state.selectedSubcategories.length === 1 && handleSubFilter("");
    } catch {
    } finally {
      handleToggle("isLoading", false);
    }
  };

  const getHighlightedText = (text: string) => {
    if (!query) return text;
    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escapedQuery})`, "gi");
    const highlightedText = text.replace(regex, (match) => {
      return `<span class="text-orange">${match}</span>`;
    });

    return <span dangerouslySetInnerHTML={{ __html: highlightedText }} />;
  };

  const toggleState = (key: keyof typeof state) => {
    setState((prevState) => ({
      ...prevState,
      [key]:
        typeof prevState[key] === "boolean" ? !prevState[key] : prevState[key],
    }));
  };

  const handlePurchaseProcess = async (item: ISearch) => {
    if (state.isProcessing) return;
    toggleState("isProcessing");
    setState((prev) => ({
      ...prev,
      selectedItemId: item,
    }));
    trackEvent(
      item.buy_now_price !== null ? "checkout_started" : "bid_started",
      JSON.stringify({ itemId: item.id })
    );
    if (isAuthenticated) {
      handleUserNameCheck(
        item.buy_now_price !== null ? "isCheckoutModal" : "isBidNow"
      );
    } else {
      state.status === "unclaimed" || state.status === "delisted"
        ? setState((pre) => ({ ...pre, isEmailModal: true }))
        : login();
    }
    trackEvent(
      "purchase_attempt",
      JSON.stringify({ status: "unauthenticated" })
    );
    toggleState("isProcessing");
  };

  const handleUserNameCheck = async (val: keyof typeof state) => {
    try {
      const response = await CheckUserName(getToken);
      if (response.data.hasUsername) {
        toggleState(val);
      } else {
        toggleState("isUserNameModal");
        trackEvent(
          "purchase_attempt",
          JSON.stringify({ status: "missing_username" })
        );
      }
    } catch {
      console.error("Unable to check the username");
    }
  };

  const handleUserNameSubmit = async (val: keyof typeof state) => {
    handleMessage("Username saved successfully");
    toggleState("isUserNameModal");
    toggleState(val);
  };

  const columns = [
    {
      key: "entity",
      header: "",
      className: "w-40",
      render: (value: any, row: any) => (
        <div className="name">
          {row.image_url ? (
            <img src={row.image_url} className="image" alt="User" />
          ) : (
            <div
              style={{ borderRadius: "4px 4px 0px 0px" }}
              className={`user-img text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center chat-image`}
            >
              <i className="fa-solid fa-user" style={{ fontSize: 20 }}></i>
            </div>
          )}
          <div className="name-item">
            <span className="item-name">{getHighlightedText(row.name)}</span>
            <p className="item-text font-100">{row.bio}</p>
          </div>
        </div>
      ),
    },
    {
      key: "category",
      header: "Category",
      render: (value: any) => (
        <div className="font-inter-500-16 line-18">{value}</div>
      ),
    },
    {
      key: "subcategory",
      header: "Subcategory",
      render: (value: any) => (
        <div className="font-inter-500-16 line-18">{value}</div>
      ),
    },
    {
      key: "fan_username",
      header: "Fan1",
      render: (value: any, row: any) => (
        <>
          {value !== null ? (
            <Link
              className="text-decoration-none font-inter-500-16  text-light-purple line-18"
              to={`/u/${value}`}
            >
              <span onClick={(e) => e.stopPropagation()}>@{value}</span>
            </Link>
          ) : row.status === "available" && row.is_buy ? (
            <span
              className="font-400 cursor-pointer navtorank"
              onClick={(e) => {
                e.stopPropagation();
                if (isAuthenticated) {
                  handlePurchaseProcess(row);
                } else {
                  login();
                }
              }}
            >
              Buy Now <i className="ms-1 fa-solid fa-bag-shopping"></i>
            </span>
          ) : row.status === "biddable" ? (
            <span
              className="font-inter-400-15 cursor-pointer navtorank"
              onClick={(e) => {
                e.stopPropagation();
                if (isAuthenticated) {
                  handlePurchaseProcess(row);
                } else {
                  login();
                }
              }}
            >
              Bid Now <i className="ms-1 fa-solid fa-gavel"></i>
            </span>
          ) : (
            <>---</>
          )}
        </>
      ),
    },
    {
      key: "buy_now_price",
      header: "Price",
      render: (value: any) => (
        <div className="font-inter-500-16">
          <div className="font-inter-500-16 line-18">{handlePrice(value)}</div>
        </div>
      ),
    },
    {
      key: "value",
      header: "Value",
      render: (value: any) => (
        <div className="font-inter-500-16">
          <div className="font-inter-500-16 line-18">
            {value === null ? <>---</> : <>{handlePrice(value)}</>}
          </div>
        </div>
      ),
    },
  ];

  const data =
    state.searches &&
    state.searches.map((item: ISearch) => ({
      id: item.id,
      public_id: item.public_id,
      name: item.name,
      image_url: item.image_url,
      bio: item.bio,
      category: item.category,
      subcategory: item.subcategory,
      buy_now_price: item.buy_now_price,
      value: item.value,
      is_buy: item.is_buy,
      fan_username: item.fan_username,
      min_bid_price: item.min_bid_price,
      end_time: item.end_time,
      fan_id: item.fan_id,
      status: item.status,
    }));

  return (
    <>
      {state.isLoading ? (
        <div className="loader">
          <div className="spinner"></div>
        </div>
      ) : (
        <></>
      )}
      <div className="container Search-Page">
        <div className="d-md-flex d-flex-column justify-content-between mb-2">
          <div className="heading pt-4 ms-2 title">Search Results</div>
          <div className="font-500-36 ms-2 title my-auto">
            You searched for <span className="text-orange">“{query}”</span>
          </div>
        </div>
        <div className="Search-table d-none d-md-block">
          <div className="d-flex align-items-center ms-2">
            <div className="filter-box my-1 d-flex">
              <Button
                variant="dark"
                key={"all"}
                className={`py-1 px-4 first ${
                  filter.main === "all" && "box-active"
                }`}
                label="All"
                onClick={() => handleMainFilter("all")}
              />
              {state.categories &&
                state.categories.map((value) => (
                  <Button
                    variant="dark"
                    className={`py-1 px-4 middle ${
                      filter.main === value.name && "box-active"
                    }`}
                    key={value.id}
                    label={<>{value.name}</>}
                    onClick={() => handleMainFilter(value.name, value.id)}
                  />
                ))}
              <Dropdown
                icon={
                  <Button
                    variant="dark"
                    className={`py-1 px-4 last ${
                      filter.sub === "subcategory" && "box.active"
                    }`}
                    label="Subcategory"
                    withDropdownArrow={true}
                    isOpen={
                      state.subcategories.length > 0 ? state.isOpen : false
                    }
                  />
                }
              >
                <div style={{ width: "150px" }}>
                  {state.subcategories &&
                    state.subcategories.map((subcategory) => (
                      <div key={subcategory.id}>
                        {state.selectedSubcategories.includes(
                          subcategory.id
                        ) ? (
                          <p className="selected-category">
                            {subcategory.name}
                            <i
                              className="fa-solid fa-xmark"
                              onClick={() =>
                                handleRemoveSubcategory(subcategory.id)
                              }
                            />
                          </p>
                        ) : (
                          <p
                            onClick={() =>
                              handleSubcategorySelection(subcategory.id)
                            }
                          >
                            {subcategory.name}
                          </p>
                        )}
                      </div>
                    ))}
                </div>
              </Dropdown>
            </div>

            <div className="filter-box my-1 ms-3 d-flex">
              <Button
                variant="dark"
                className={`py-1 px-4  first ${
                  state.secondfilter === "" && "box-active"
                }`}
                label="All"
                onClick={() => handleSecondFilter("")}
              />
              <Button
                variant="dark"
                className={`py-1 px-4 middle ${
                  state.secondfilter === "available" && "box-active"
                }`}
                label="Available"
                onClick={() => handleSecondFilter("available")}
              />
              <Button
                variant="dark"
                className={`py-1 px-4 last ${
                  state.secondfilter === "ranked" && "box-active"
                }`}
                label="Ranked"
                onClick={() => handleSecondFilter("ranked")}
              />
            </div>

            <div className="maxPrice ms-3 d-flex">
              <span className="maxLabel">Max Price</span>
              <InputBox
                className="maxbox ms-2"
                name="maxPrice"
                type={"number"}
                value={state.maxPrice.toString()}
                onChange={handleMaxFilters}
              />
            </div>
            <div className="maxValue ms-3 d-flex">
              <span className="maxLabel">Max Value</span>
              <InputBox
                className="maxbox ms-2"
                disabled={state.secondfilter === "available"}
                name="maxValue"
                type={"number"}
                value={state.maxValue.toString()}
                onChange={(e) => {
                  if (state.secondfilter !== "available") {
                    handleMaxFilters(e);
                  }
                }}
              />
            </div>
          </div>
          <div className="main-table ps-2">
            <div className="shadow-box mb-3">
              <Table
                columns={columns}
                data={data}
                className="search-table"
                headClassName="head"
                rowClassName="search-table-tr"
                cellClassName="ranking-td"
                onRowClick={(row) =>
                  navigate(`/${row.public_id}`, { state: { id: row.id } })
                }
              />
            </div>
            <div className="lower-text text-center">
              <h4 className="fs-5">Didn’t find what you’re looking for?</h4>
              <Button
                label={<>Submit Request</>}
                className="col-2"
                onClick={() => handleToggle("isFavModalOpen")}
              />
            </div>
          </div>
        </div>

        <div className="Search-mobile-table d-block d-md-none">
          <div className="mt-2 ms-2 pe-2 align-items-center">
            <div
              className="head-part"
              onClick={() => handleToggle("isFilterOpen")}
            >
              Filter
              <i
                className={`fa-solid fa-angle-down my-auto ms-2`}
                style={{
                  transform: `rotate(${!state.isFilterOpen ? 0 : 180}deg)`,
                  transition: "transform 0.7s ease",
                }}
              ></i>
            </div>

            <div
              className={`${
                state.isFilterOpen ? "filter-div h-100 mt-2 mb-3" : "d-none"
              }`}
            >
              <div className="mt-3 status-div">
                <h6>Status</h6>
                <div className="ms-0 gap-2 row">
                  <Button
                    variant="dark"
                    className={`col-3 circle-border ${
                      state.secondfilter === "" && "box-active"
                    }`}
                    label="All"
                    onClick={() => handleSecondFilter("")}
                  />

                  <Button
                    variant="dark"
                    className={`col-4 circle-border ${
                      state.secondfilter === "available" && "box-active"
                    }`}
                    label="Available"
                    onClick={() => handleSecondFilter("available")}
                  />
                  <Button
                    variant="dark"
                    className={`col-4 circle-border ${
                      state.secondfilter === "ranked" && "box-active"
                    }`}
                    label="Ranked"
                    onClick={() => handleSecondFilter("ranked")}
                  />
                </div>
              </div>

              <div className="row mt-3 mx-0 ">
                <div className="col-8 m-0 p-0">
                  <h6>Category</h6>
                  <div className="d-inline-flex flex-wrap gap-2 category-div">
                    <Button
                      variant="dark"
                      key={"all"}
                      className={`circle-border ${
                        filter.main === "all" && "box-active"
                      }`}
                      label="All"
                      onClick={() => handleMainFilter("all")}
                    />
                    {state.categories &&
                      state.categories.map((value) => (
                        <Button
                          variant="dark"
                          className={`circle-border ${
                            filter.main === value.name && "box-active"
                          }`}
                          key={value.id}
                          label={value.name}
                          onClick={() => handleMainFilter(value.name, value.id)}
                        />
                      ))}
                    <Dropdown
                      icon={
                        <Button
                          variant="dark"
                          className={`subcategory-border ${
                            filter.sub === "subcategory" && "box.active"
                          }`}
                          label="Subcategory"
                          withDropdownArrow={true}
                          isOpen={
                            state.subcategories.length > 0
                              ? state.isOpen
                              : false
                          }
                        />
                      }
                    >
                      <div style={{ width: "150px" }}>
                        {state.subcategories &&
                          state.subcategories.map((subcategory) => (
                            <div key={subcategory.id}>
                              {state.selectedSubcategories.includes(
                                subcategory.id
                              ) ? (
                                <p className="selected-category">
                                  {subcategory.name}
                                  <i
                                    className="fa-solid fa-xmark"
                                    onClick={() =>
                                      handleRemoveSubcategory(subcategory.id)
                                    }
                                  />
                                </p>
                              ) : (
                                <p
                                  onClick={() =>
                                    handleSubcategorySelection(subcategory.id)
                                  }
                                >
                                  {subcategory.name}
                                </p>
                              )}
                            </div>
                          ))}
                      </div>
                    </Dropdown>
                  </div>
                </div>

                <div className="col-4 m-0 p-0">
                  <h6>Price/Value</h6>
                  <div className="maxPrice w-100 d-flex mb-2">
                    <span className="maxLabel">Max Price</span>
                    <InputBox
                      className="w-100 maxbox ms-2"
                      name="maxPrice"
                      type={"number"}
                      value={state.maxPrice.toString()}
                      onChange={handleMaxFilters}
                    />
                  </div>
                  <div className="maxValue w-100 d-flex">
                    <span className="maxLabel">Max Value</span>
                    <InputBox
                      className="w-100 maxbox ms-2"
                      disabled={state.secondfilter === "available"}
                      name="maxValue"
                      type={"number"}
                      value={state.maxValue.toString()}
                      onChange={(e) => {
                        if (state.secondfilter !== "available") {
                          handleMaxFilters(e);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="search-mobile my-md-3 shadow-box">
            {state.searches &&
              state.searches.map((item, index) => (
                <Slab
                  onClick={() =>
                    navigate(`/${item.public_id}`, { state: { id: item.id } })
                  }
                  key={index}
                  bgcolor={"bg-transparent search-border"}
                  className="d-flex justify-content-between align-items-start"
                  content={
                    <>
                      <div className="d-flex w-75">
                        <img
                          src={item.image_url}
                          className="image"
                          alt="User"
                        />
                        <div className="ms-2">
                          <div className="font-500-18 slabFigName">
                            {getHighlightedText(item.name)}
                          </div>
                          <div className="d-flex">
                            <p className="item-text me-1 font-inter-300-13">
                              {item.category}
                            </p>
                            <p className="item-text font-inter-300-13">
                              {item.subcategory}
                            </p>
                          </div>
                          <p className="item-text font-inter-300-13 slabFanName">
                            Fan1:{" "}
                            <span className="text-light-purple">
                              {item.fan_username !== null ? (
                                <Link
                                  to={`/u/${item.fan_username}`}
                                  onClick={(e) => e.stopPropagation()}
                                  className="text-light-purple text-decoration-none"
                                >
                                  @{item.fan_username}
                                </Link>
                              ) : item.status === "available" && item.is_buy ? (
                                <span
                                  className="font-400 cusrsor-pointer "
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (isAuthenticated) {
                                      handlePurchaseProcess(item);
                                    } else {
                                      login();
                                    }
                                  }}
                                >
                                  Buy Now
                                  <i className="ms-1 fa-solid fa-bag-shopping"></i>
                                </span>
                              ) : item.status === "biddable" ? (
                                <span
                                  className="font-inter-400-15 cursor-pointer navtorank"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (isAuthenticated) {
                                      handlePurchaseProcess(item);
                                    } else {
                                      login();
                                    }
                                  }}
                                >
                                  Bid Now{" "}
                                  <i className="ms-1 fa-solid fa-gavel"></i>
                                </span>
                              ) : (
                                <span className="text-white">---</span>
                              )}
                            </span>
                          </p>
                        </div>
                      </div>

                      {/* Right Side: Price and Value */}
                      <div className="d-flex flex-column text-start slabprice">
                        <p className="">
                          Price: <span>{handlePrice(item.buy_now_price)}</span>
                        </p>
                        <p className="">
                          Value:{" "}
                          <span>
                            {item.value === null ? (
                              <>---</>
                            ) : (
                              <>{handlePrice(item.value)}</>
                            )}
                          </span>
                        </p>
                      </div>
                    </>
                  }
                />
              ))}
          </div>

          <div className="lower-text text-start mb-3 d-flex">
            <h4 className="font-500-18 text-left">
              Didn’t find what you’re looking for?
            </h4>
            <Button
              label={<>Submit Request</>}
              onClick={() => handleToggle("isFavModalOpen")}
            />
          </div>
        </div>
      </div>

      <FavRequestModal
        isVisible={state.isFavModalOpen}
        data={formData}
        onClick={handleFavRequest}
        onClose={() => handleToggle("isFavModalOpen")}
        handleInputChange={handleInputChange}
      />

      {state.isCheckoutModal && (
        <StripeCheckoutForm
          isVisible={state.isCheckoutModal}
          itemIds={state.selectedItemId.id}
          onClose={() => toggleState("isCheckoutModal")}
          onClick={() => {
            toggleState("isCheckoutModal");
            handleMessage(
              "",
              `<div class='text-white'><div class='font-500-36'>You are now Fan1 to ${state.selectedItemId.name}!</div></div>`
            );
          }}
        />
      )}

      {state.isBidNow && (
        <AuctionModal
          isVisible={state.isBidNow}
          auctionData={{
            id: state.selectedItemId.id,
            name: state.selectedItemId.name,
            image: state.selectedItemId.image_url,
            min_bid_price: state.selectedItemId.min_bid_price,
            endtime: state.selectedItemId.end_time,
          }}
          onClose={() => toggleState("isBidNow")}
        />
      )}

      {state.isUserNameModal && (
        <UserNameModal
          isVisible={state.isUserNameModal}
          onClose={() => {
            toggleState("isUserNameModal");
          }}
          isBuy={state.selectedItemId.is_buy}
          onClick={() =>
            handleUserNameSubmit(
              state.selectedItemId.buy_now_price !== null
                ? "isCheckoutModal"
                : "isBidNow"
            )
          }
        />
      )}
    </>
  );
};
export default SearchPage;
